// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2fxrQ","dragIcon":"SortableItem_dragIcon__3y782","disabled":"SortableItem_disabled__PXUqO"};